import { ChevronDownIcon, PopoverMenu } from '@st/theme'
import { clsx } from 'clsx'
import { ReactNode } from 'react'

export function VisualSelect({
  placeholder,
  children,
  className,
  isOpen,
  onOpenChange
}: {
  placeholder: ReactNode
  children: ReactNode
  className?: string
  isOpen: boolean
  onOpenChange?: (isOpen: boolean) => void
}) {
  return (
    <PopoverMenu
      isControlled={true}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      trigger={
        <button
          className={clsx(
            'inline-flex items-center justify-between gap-x-1.5 rounded-md bg-white px-3 py-1 ring-1 ring-inset ring-gray-300',
            className
          )}
        >
          <span className="flex-grow text-left">{placeholder}</span>
          <ChevronDownIcon className="-mr-1 size-5 text-gray-400" />
        </button>
      }
      placement="bottom-start"
    >
      <div className="z-10 mt-2 flex w-64 flex-col gap-2 rounded-md bg-white p-2 shadow-lg ring-1 ring-black/5 focus:outline-none">
        {children}
      </div>
    </PopoverMenu>
  )
}

type VisualSelectSectionProps = {
  title: string
  children: React.ReactNode
  layout?: 'rows' | 'grid'
}

export function VisualSelectSection({
  title,
  children,
  layout = 'rows'
}: VisualSelectSectionProps) {
  return (
    <div>
      <div className="mb-1 px-2 pt-2">
        <h3 className="text-xs font-semibold uppercase tracking-wider text-gray-500">{title}</h3>
      </div>
      {layout === 'grid' ? (
        <div className="flex flex-wrap justify-around px-2">{children}</div>
      ) : (
        <div className="flex flex-col px-2">{children}</div>
      )}
    </div>
  )
}
